'use client';
import { useRouter } from 'next/navigation';

import Button from '@/components/v2/Button';

const HistoryBackButton = () => {
  const router = useRouter();
  const handleHistoryBack = () => {
    router.back();
  };
  return (
    <Button variant={'tonalgray'} className="w-[140px] md:w-[160px]" onClick={handleHistoryBack}>
      이전 페이지
    </Button>
  );
};

export default HistoryBackButton;
